import { BaseModel } from "sjs-base-model";

export default class ProvvigioniComissioniFormModel extends BaseModel {
    public readonly bankCommissionsPercentage: string = "";
    public readonly bankCommissionsAmount: string = "";
    public readonly agentCommissionsPercentage: string = "";
    public readonly agentCommissionsAmount: string = "";
    public readonly maxTotalPercentage: number = 0;
    public readonly maxTotalAmount: number = 0;

    constructor(data: Partial<ProvvigioniComissioniFormModel>) {
        super();

        this.update(data);
    }
}
